import { Controller } from "stimulus"

import Chart from 'chart.js/auto';
import ChartDataLabels from 'chartjs-plugin-datalabels';
Chart.register(ChartDataLabels);

export default class extends Controller {
  static targets = ["chartElement"];

  // chartElement() {
  //   // Use a target for this!
  //   return document.getElementById('bank_chart');
  // }

  buildChart(json) {
    //var chart_element = this.chartElementTarget; // Have no idea why ChartJs doesn't like a stimulus target?!
    var chart_element = document.getElementById('bank_chart'); // For some reason we have to retreive the element like this

    //window.myjson = json;

    var total_amount = json.map(row => row.amount).reduce((a,b)=>a+b);

    const money = new Intl.NumberFormat('sv-SE', {
      style: 'currency',
      currency: 'SEK',
      // These options are needed to round to whole numbers if that's what you want.
      minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
      maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
    });

    new Chart(
      chart_element,
      {
        type: 'bar',
        // data: data,
        data: {
          labels: [''], //json.map(row => row.label),
          datasets: json.map(row => ({
            label: row.label, 
            data: [row.amount],
            backgroundColor: function(context) {
              return ['#fee884', '#6cce62'][context.datasetIndex];
            },
            datalabels: {
              labels: {
                total: {
                  align: 'end',
                  anchor: 'end',
                  color: '#666',
                  // color: function(context) {
                  //   return context.dataset.backgroundColor;
                  // },
                  font: function(context) {
                    var w = context.chart.width;
                    return {
                      //size: w < 512 ? 12 : 14,
                      size: 20,
                      weight: 'bold',
                    };
                  },
                  formatter: function(value, context) {
                    // Only show this label for the last item
                    return context.datasetIndex == context.chart.data.datasets.length-1 ? money.format(total_amount) : '';
                  },
                },
                amount: { 
                  align: 'bottom',
                  formatter: function(value, ctx) {
                    return money.format(value);
                  }
                },
                label: { 
                  align: 'top',
                  formatter: function(value, ctx) {
                    //console.log(ctx.dataset.label);
                    //console.log(json[ctx.dataIndex]);
                    //return ctx.chart.data.datasets[ctx.dataIndex];
                    return ctx.dataset.label;
                  }
                },
              }
            },
            //backgroundColor: 'rgba(255, 255, 0, 0.1)'
          })),
        },
        options: {
          scales: {
            x: {
              stacked: true
            },
            y: {
              stacked: true,
              max: (Math.trunc(total_amount*1.1 / 20000)+1) * 20000
            }
          },
          plugins: {
            legend: {
              position: 'top',
              reverse: true
            },
            datalabels: {
              //color: '#36A2EB',
              font: {
                size: '20',
                weight: '400'
              },
              labels: {
                amount: {
                  font: {
                    weight: 'bold'
                  },
                },
                label: {
                  font: {
                    size: '15',
                    weight: 'normal'
                  },
                }
              }
            }
          }
        }
      }
    );
  }

  connect() {
    var chart_element = this.chartElementTarget;

    var chartRequest = new Request.JSON({
      url: '/bank_accounts/economic_overview',
      method: 'get',
      onRequest: function() {
        return chart_element.addClass('loading');
      },
      onSuccess: this.buildChart
      // onSuccess: function(json) {
      //   this.buildChart(json);
      //   // var d, format;
      //   // d = json.sort(function(a, b) {
      //   //   return formatDate.parse(a.date) - formatDate.parse(b.date);
      //   // });
      //   // switch (period) {
      //   //   case 'days':
      //   //     format = '%e %b';
      //   //     break;
      //   //   case 'months':
      //   //     format = "%b '%y";
      //   //     break;
      //   //   case 'years':
      //   //     format = '%Y';
      //   // }
      //   // svg.datum(d).call(chart, format);
      //   return chart_element.removeClass('loading');
      // }
    });

    chartRequest.send();
  }
}